export default "__VITE_ASSET__DLljOJil__"